import { roles } from '@nxsys/store/constants';
import StatutoryLeave from '../../../modules/statutory/listing/leave';
import StatutoryPayment from '../../../modules/statutory/listing/payment';
import StatutoryDetail from '../../../modules/statutory/details';

export const statutoryPaymentConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/statutory-leave',
    element: <StatutoryLeave />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/statutory-payment',
    element: <StatutoryPayment />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/statutory-leave/:type/:id',
    element: <StatutoryDetail />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/statutory-payment/:type/:id',
    element: <StatutoryDetail />,
  },
];
